
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { isAllowedCallbackUrl } from '@/services/authorization/mobile'

const MOBILE_CALLBACK_KEY = 'mobile_callback_url'

interface TabsInterface {
  name: string,
  to: {
    name: string
  }
}

export default Vue.extend({
  name: 'MainView',
  data: () => ({
    fromOldLK: false,
    tabs: [
      {
        name: 'main.tabs.signIn',
        to: {
          name: 'SignIn'
        }
      },
      {
        name: 'main.tabs.signUp',
        to: {
          name: 'SignUp'
        }
      }
    ] as Array<TabsInterface>,
    cookiesBannerHeight: 0,
    cookiesBannerEL: null as HTMLElement | null,
    resizeObserver: null as ResizeObserver | null
  }),
  computed: {
    ...mapGetters('user', ['getIsAuthenticated']),
    heightSubtracted () {
      const subtracted = this.cookiesBannerHeight ? `${this.cookiesBannerHeight}px - 41px` : '125px'
      if (this.maw(959)) {
        return `calc(100 * var(--tVH) - ${subtracted} - 10vh)`
      }
      if (this.maw(767)) {
        return `calc(100 * var(--tVH) - ${subtracted} - 7vh)`
      }
      return 'auto'
    }
  },
  watch: {
    getIsAuthenticated (isAuthenticated): void {
      const vm = this as any
      if (isAuthenticated) {
        const callbackUrl = sessionStorage.getItem(MOBILE_CALLBACK_KEY)
        if (callbackUrl) {
          vm.showMobileAppAuthPopup(callbackUrl)
        } else {
          vm.$router.replace({ name: 'whitelistID' })
        }
      }
    }
  },
  methods: {
    handleTabClick (to: TabsInterface) {
      const vm = this as any
      if (vm.$route.name !== to.name) {
        vm.$router.replace(to)
      }
    },
    calculateCookiesBannerHeight (): void {
      if (this.cookiesBannerEL) {
        this.cookiesBannerHeight = this.cookiesBannerEL.clientHeight
      }
    },
    showMobileAppAuthPopup (callbackUrl: string): void {
      const vm = this as any
      const title = vm.$t('mobileAppAuth.title')
      const content = vm.$t('mobileAppAuth.content')
      const confirmTitle = vm.$t('mobileAppAuth.confirm')
      const declineTitle = vm.$t('mobileAppAuth.decline')
      vm.$router.replace({ name: 'whitelistID' }).then(() => {
        vm.$store.dispatch('popupModule/openPopup', {
          type: 'confirmPopup',
          letDefaultClose: false,
          title,
          content,
          actions: [
            {
              title: confirmTitle,
              isAccent: true,
              callback () {
                vm.$store.commit('popupModule/setClosed')
                sessionStorage.removeItem(MOBILE_CALLBACK_KEY)
                vm.$services.authorization.mobile.requestAuthCode().then((response: any) => {
                  if (response.success && response.data?.code) {
                    const redirectUrl = new URL(callbackUrl)
                    redirectUrl.searchParams.set('code', response.data.code)
                    window.location.href = redirectUrl.toString()
                  }
                })
              }
            },
            {
              title: declineTitle,
              isAccent: false,
              callback () {
                vm.$store.commit('popupModule/setClosed')
                sessionStorage.removeItem(MOBILE_CALLBACK_KEY)
              }
            }
          ]
        })
      })
    }
  },
  created (): void {
    const vm = this as any
    this.fromOldLK = Boolean(this.$route.query.from_oldlk !== undefined)
    const callbackUrl = this.$route.query.callback_url as string | undefined
    if (callbackUrl && isAllowedCallbackUrl(callbackUrl)) {
      sessionStorage.setItem(MOBILE_CALLBACK_KEY, callbackUrl)
    }
    if (vm.getIsAuthenticated) {
      const storedCallbackUrl = sessionStorage.getItem(MOBILE_CALLBACK_KEY)
      if (storedCallbackUrl) {
        vm.showMobileAppAuthPopup(storedCallbackUrl)
      } else {
        vm.$router.replace({ name: 'whitelistID' })
      }
    }
    this.cookiesBannerEL = document.querySelector('.mainpage-cookies-banner')
    if (this.cookiesBannerEL) {
      this.resizeObserver = new ResizeObserver(this.calculateCookiesBannerHeight)
      this.resizeObserver.observe(this.cookiesBannerEL)
    }
  },
  beforeDestroy () {
    if (this.cookiesBannerEL) {
      this.resizeObserver.unobserve(this.cookiesBannerEL)
    }
  }
})
